import { gql } from 'graphql-request'

export const GlobalMenuQuery = gql`
  query GlobalMenu(
    $locale: LocaleInputType!
  ) {
    Menu(locale: $locale) {
      maskShape ${fragmentMaskShapeQuery}
      groups {
        id
        links {
          id
          link ${fragmentLinkQuery}
          color
        }
      }
    }
  }
`
